import React from 'react'
import PropTypes from 'prop-types'

export default class JobModuleCard extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    moduleId: PropTypes.string.isRequired,
    children: PropTypes.any,
    onSubtitleClicked: PropTypes.func
  }

  handleSubtitleClicked = () => {
    this.props.onSubtitleClicked(this.props.moduleId)
  }

  render() {
    return (
      <div style={styles.cardContainer}>
        <div style={styles.cardHeader}>
          <div style={styles.cardTitle}>{this.props.title}</div>
          { this.props.subtitle &&
            <div style={styles.cardSubtitle}
              onClick={this.handleSubtitleClicked}>
              { this.props.subtitle }
            </div>
          }
        </div>
        <div style={styles.cardModule}>
          {this.props.children}
        </div>
      </div>
    )
  }

}

const styles = {

  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fafafa'
  },

  cardHeader: {
    marginBottom: 20,
    marginLeft: 80,
    marginRight: 80,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },

  cardTitle: {
    color: '#212121',
    fontSize: 16,
    fontWeight: '500'
  },

  cardSubtitle: {
    cursor: 'pointer',
    fontSize: 11,
    color: '#527da3'
  },

  cardModule: {
    marginLeft: 80,
    marginRight: 80
  }

}


// WEBPACK FOOTER //
// ./src/schedule/common/modules/JobModuleCard.js